"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledStudentsSummary = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.StyledStudentsSummary = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  > div {\n    height: 100%;\n  }\n\n  .summary {\n    padding: 0 ", ";\n    height: 168px;\n    ", ";\n    flex-direction: column;\n\n    > h2 {\n      font-size: ", ";\n      margin: 0;\n    }\n\n    > p {\n      font-size: ", ";\n      margin-bottom: ", ";\n      color: ", ";\n    }\n\n    h2.see-students {\n      font-size: ", ";\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .footer {\n    ", ";\n    justify-content: flex-end;\n    padding: ", ";\n\n    > a {\n      color: ", ";\n      font-size: ", ";\n      pointer-events: none;\n    }\n\n    > i {\n      color: ", ";\n      margin-left: ", ";\n      margin-top: 1px;\n    }\n  }\n"], ["\n  > div {\n    height: 100%;\n  }\n\n  .summary {\n    padding: 0 ", ";\n    height: 168px;\n    ", ";\n    flex-direction: column;\n\n    > h2 {\n      font-size: ", ";\n      margin: 0;\n    }\n\n    > p {\n      font-size: ", ";\n      margin-bottom: ", ";\n      color: ", ";\n    }\n\n    h2.see-students {\n      font-size: ", ";\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .footer {\n    ", ";\n    justify-content: flex-end;\n    padding: ", ";\n\n    > a {\n      color: ", ";\n      font-size: ", ";\n      pointer-events: none;\n    }\n\n    > i {\n      color: ", ";\n      margin-left: ", ";\n      margin-top: 1px;\n    }\n  }\n"])), function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x5;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('horizontal');
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.xxl;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.sm;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x2;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.Typography.secondary;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.sm;
}, function (_a) {
    var Utilities = _a.theme.Utilities;
    return Utilities.Flex.center('horizontal');
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return "0 ".concat(Spacing.x3, " ").concat(Spacing.x3, " 0");
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.secondary;
}, function (_a) {
    var Typography = _a.theme.Typography;
    return Typography.Sizes.sm;
}, function (_a) {
    var Colors = _a.theme.Colors;
    return Colors.secondary;
}, function (_a) {
    var Spacing = _a.theme.Spacing;
    return Spacing.x1;
});
var templateObject_1;
